<button class="control" mat-button [matMenuTriggerFor]="accessMenu" aria-label="Access level button with menu">
  <span class="text">{{ selectedItem.label }}</span>
  <capra-icon icon="icon-caret-down"></capra-icon>
</button>

<mat-menu class="menu" #accessMenu="matMenu" [class]="menuClassName">
  <span class="menu__title">Access Type</span>

  <button
    *ngFor="let item of options"
    mat-menu-item
    class="menu__item"
    name="{{ item.id }}"
    [ngClass]="{'menu__item--selected': item.id === selectedItem.id, 'menu__item--remove': item.id === 'remove'}"
    (click)="selectItemById(item.id)"
  >
  <span class="menu__item_contents">
    <span class="menu__item__indicator"> &#9679; </span>
    <span class="menu__item__label">
        <span class="menu__item__label__title">{{ item.label }}</span>
        <span class="menu__item__label__description">{{ item.description }}</span>
    </span>
  </span>
  </button>
</mat-menu>
